import { useEffect, useLayoutEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Always scroll to the top on every navigation (PUSH/REPLACE/POP).
 *
 * The user explicitly asked for back-navigation to land at the top of the
 * page instead of trying to restore the previous scroll position. We also
 * disable the browser's native scroll restoration to override the default
 * behavior on mobile Safari/Chrome.
 */
export default function ScrollToTop() {
  const { pathname, search, hash } = useLocation();
  const prevKey = useRef(null);

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    const key = pathname + search;
    if (prevKey.current === key) return;
    prevKey.current = key;
    if (hash) return; // let browser handle anchor jumps
    // Scroll instantly and re-assert across frames to beat the browser's
    // automatic clamp/restoration on mobile.
    const apply = () => window.scrollTo(0, 0);
    apply();
    requestAnimationFrame(apply);
    setTimeout(apply, 80);
    setTimeout(apply, 250);
  }, [pathname, search, hash]);

  return null;
}
